module.exports = __webpack_public_path__ + "static/media/wand-magic.d1d9c319.svg";